import { BaseFiltroPaginate } from "resources/enums/paginate";
import { PaginateQuery } from "resources/types/shared";
import { useCallback, useState } from "react";
import { AnuncioStatusEnum } from "features/anuncio/typings";

interface FiltroAnuncios extends PaginateQuery {
  statusId: AnuncioStatusEnum | undefined;
}

function useFiltroAnuncios() {
  const [filtro, setFiltro] = useState<FiltroAnuncios>({
    page: 1,
    limit: BaseFiltroPaginate.Limit,
    search: "",
    statusId: undefined,
  });

  const onChangeFiltro = useCallback((_filtro: Partial<FiltroAnuncios>) => {
    setFiltro((state) => ({ ...state, ..._filtro }));
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
  };
}

export default useFiltroAnuncios;
